import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { Col, Form, Input, InputNumber, Row, Icon, Button, Divider, Checkbox } from 'antd';
import { LayerForm } from './LayerForm';

@withRouter
@inject('store')
@observer
export class GLayerTabComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            layers: (props.data && props.data.layers) || []
        };
    }

    handleAddLayer() {
        let next = [...this.state.layers];
        next.push({
            qty: 0,
            spread: 0,
            tp: 0,
            delay: 0
        });
        this.setState({ layers: next });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Fragment>
                <Row gutter={14}>
                    <Col md={2}>
                        <Form.Item label="Open Time (Mins)">
                            {getFieldDecorator('open_time', {
                                initialValue: 4
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                    <Col md={3}>
                        <Form.Item label="Cooldown (Mins)">
                            {getFieldDecorator('cooldown_time', {
                                initialValue: 1
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                    <Col md={3}>
                        <Form.Item label="Entry Protection">
                            {getFieldDecorator('entry_protection', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">Trading Zone</Divider>
                <Row gutter={14}>
                    <Col md={2}>
                        <Form.Item label="Lower Limit %">
                            {getFieldDecorator('trading_zone_min', {
                                initialValue: -0.5
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                    <Col md={3}>
                        <Form.Item label="Upper Limit %">
                            {getFieldDecorator('trading_zone_max', {
                                initialValue: 0.5
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                </Row>

                <Divider orientation="left">Layers</Divider>

                {this.state.layers.map((o, i) => {
                    return (
                        <LayerForm
                            key={i}
                            index={i}
                            updateLayer={data => {
                                let next = [...this.state.layers];
                                next[i] = data;
                                this.setState({ layers: next });
                                this.props.updateTab({ layers: next });
                            }}
                            deleteLayer={() => {
                                let next = [...this.state.layers];
                                next.splice(i, 1);
                                this.setState({ layers: next });
                                this.props.updateTab({ layers: next });
                            }}
                            data={o}
                        />
                    );
                })}

                <Button
                    type="dashed"
                    onClick={this.handleAddLayer.bind(this)}
                    style={{ width: '60%' }}
                >
                    <Icon type="plus" /> Add layer
                </Button>

                <Divider orientation="left">Stop Loss</Divider>

                <Row gutter={24}>
                    <Col md={2}>
                        <Form.Item label="Enable Stop Loss">
                            {getFieldDecorator('stop_loss_enabled', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>
                    <Col md={3}>
                        <Form.Item label="Stop Loss %">
                            {getFieldDecorator('stop_loss_percent', {
                                initialValue: 4
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                    <Col md={4}>
                        <Form.Item label="Cooldown applied on trigger">
                            {getFieldDecorator('stop_loss_cooldown_time', {
                                initialValue: 10
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>

                    <Col md={2}>
                        <Form.Item label="Stop trading on trigger">
                            {getFieldDecorator('stop_loss_stop_trading_on_trigger', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}

export const LayerTab = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        return data;
    },
    onValuesChange(props, changedFields, allValues) {
        props.updateTab(allValues);
    }
})(GLayerTabComponent);



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/SettingsView/LayerTab.js